<template>
  <div>
    <a-modal v-model="visible" title="Edit this event" :width="680" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <button class="btn btn-danger float-left" key="delete" @click="handleDelete">Delete</button>
        <button class="btn" key="back" @click="handleCancel">Cancel</button>
        <button class="btn btn-primary" key="submit" :loading="loading" @click="handleSubmit">Update Event</button>
      </template>

      <a-spin :spinning="spining">
        <a-form :form="form">
          <div class="row">
            <div class="col-md-12 mb-2">
              <a-form-item label="Title">
                <a-input
                  placeholder="Event title"
                  v-decorator="['title', {rules: [{ required: true, message: 'Please input event title!' }]}]"
                />
              </a-form-item>
            </div>
            <div class="col-md-12 mb-2">
              <a-form-item label="Description">
                <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
              </a-form-item>
            </div>
            <div class="col-md-12 mb-2">
              <a-form-item label="Event Image (Optional)">
                <div v-if="existingImageUrl" class="mb-2">
                  <img :src="existingImageUrl" alt="Event Image" style="max-height: 100px; border-radius: 4px;" />
                  <br/>
                  <small>Upload a new image to replace</small>
                </div>
                <input type="file" @change="handleImageChange" accept="image/*" class="form-control" />
              </a-form-item>
            </div>
            <a-divider orientation="left">Scheduling & Type</a-divider>
            <div class="col-md-6 mb-2">
              <a-form-item
                label="Event Type"
              >
                <a-select
                  width="100%"
                  v-decorator="[
                    'event_type',
                    {rules: [{ required: true, message: 'Please select an event type!!' }],  initialValue: 'O' },
                  ]"
                  @change="handleEventTypeChange"
                >
                  <a-select-option v-for="eventType in eventTypes" :value="eventType.value" :key="eventType.value">
                  {{eventType.name}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-2 col-6 mb-2">
              <a-form-item label="All day?">
                <a-switch
                  checkedChildren="Yes" unCheckedChildren="No"
                  v-decorator="[
                    'all_day',
                    {
                      valuePropName: 'checked',
                      initialValue: false,
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <!-- <div class="col-md-2 col-6 mb-2">
              <a-form-item label="Working day?">
                <a-switch
                  checkedChildren="Yes" unCheckedChildren="No"
                  v-decorator="[
                    'in_attendance',
                    {
                      valuePropName: 'checked',
                      initialValue: false,
                    },
                  ]"
                :disabled="!!form.getFieldValue('end_date')"
                />
              </a-form-item>
            </div> -->
            <!-- <div class="col-md-2 col-6 mb-2">
              <a-form-item label="Weekend?">
                <a-switch
                  checkedChildren="Yes" unCheckedChildren="No"
                  v-decorator="[
                    'weekend',
                    {
                      valuePropName: 'checked',
                      initialValue: false,
                    },
                  ]"
                />
              </a-form-item>
            </div> -->
            <div class="col-md-6 mb-2">
              <a-form-item
                label="Start Date"
              >
              <a-date-picker
                v-decorator="[
                'start_date',
                {rules: [{ required: true, message: 'Please input a start date' }], initialValue: calendarEventDate},
                ]"
                :format=dateFormat
                 @change="onStartOrEndDateChange"/>
              </a-form-item>
            </div>
            <div class="col-md-6 mb-2">
              <a-form-item
                label="End Date"
              >
              <a-date-picker
                v-decorator="[
                'end_date',
                {rules: [{ required: false, message: 'Please input an end date' }],},
                ]"
                :format=dateFormat
                 @change="onStartOrEndDateChange" />
              </a-form-item>
            </div>
            <div class="col-md-6 mb-2" v-if="!form.getFieldValue('all_day')">
              <a-form-item
                label="Start Time"
              >
                <a-time-picker
                :open="open"
                @openChange="handleTimePickerOpenChange"
                v-decorator="[
                  'start_time',
                  {rules: [], initialValue: moment()},
                  ]"
                  use12Hours :format="timeFormat"
                >
                  <a-button slot="addon" size="small" type="primary" @click="handleTimePickerClose">Ok</a-button>
                </a-time-picker>
              </a-form-item>
            </div>
            <div class="col-md-6 mb-2" v-if="!form.getFieldValue('all_day')">
              <a-form-item
                label="End Time"
              >
                <a-time-picker
                :open.sync="open2"
                v-decorator="[
                  'end_time',
                  {rules: [], initialValue: moment()},
                  ]"
                  use12Hours :format="timeFormat"
                >
                  <a-button slot="addon" size="small" type="primary" @click="handleTimePickerClose">Ok</a-button>
                </a-time-picker>
              </a-form-item>
            </div>
          </div>
          <!-- <div class="working-days-during-holidays" v-if="form.getFieldValue('end_date')">
            <a-divider />
            <p class="pt-3">During the selected holiday period ({{ form.getFieldValue('start_date') ? form.getFieldValue('start_date').format('DD-MM-YYYY') : 'Start Date' }} to {{ form.getFieldValue('end_date') ? form.getFieldValue('end_date').format('DD-MM-YYYY') : 'End Date' }}), indicate the days if staff will be attending/working.</p>
            <div class="row">
              <div class="col-md-6 mb-2">
                <a-form-item label="Date">
                  <a-date-picker
                    v-model="selectedDate"
                    :disabledDate="disabledWorkingDate"
                    @change="handleDateChange"
                    placeholder="Select working dates"
                  />
                  <div class="mt-2">
                    <span v-for="date in selectedDates" :key="date" class="mx-1" style="background-color: #1b55e3 !important; color: #fff">
                      {{ date }}
                      <a @click="removeDate(date)" class="text-white ml-2">x</a>
                    </span>
                  </div>
                </a-form-item>
              </div>
            </div>
          </div> -->
          <!-- Staff Working Days Section -->
        <div v-if="isHoliday && form.getFieldValue('start_date') && form.getFieldValue('end_date')">
          <a-divider orientation="left">Staff Working Days</a-divider>
            <p>
              Select the dates staff will work between
              {{ form.getFieldValue('start_date') ? form.getFieldValue('start_date').format('DD-MM-YYYY') : '' }}
                and
              {{ form.getFieldValue('end_date') ? form.getFieldValue('end_date').format('DD-MM-YYYY') : '' }}.
            </p>

              <div v-if="workingDays.length">
                <!-- Select All Checkbox -->
                <div class="mb-2">
                <a-checkbox
                :indeterminate="isIndeterminate"
                :checked="checkAll"
                :disabled="isWorkingDaysDisabled"
                @change="handleCheckAllChange"
              >
              {{ checkAll ? 'Deselect All' : 'Select All' }}
            </a-checkbox>
          </div>

          <!-- List of dates with checkboxes -->
          <a-table
            :columns="workingDayColumns"
            :data-source="workingDaysData"
            :pagination="false"
            size="small"
            bordered
            row-key="date"
          >
        <template slot="checkbox" slot-scope="text, record">
          <a-checkbox
          :value="record.date"
          :checked="selectedDates.includes(record.date)"
          :disabled="isWorkingDaysDisabled"
          @change="(e) => handleCheckboxChange(e, record.date)"
        />
      </template>
    </a-table>

    <p
      v-if="isWorkingDaysDisabled"
      style="color: #faad14; font-size: 12px; margin-top: 2px;"
    >
      * Staff working days are disabled because the audience is 'Students' or 'Parents'.
    </p>
  </div><div v-else>
    <p class="text-muted">Please select both start and end dates.</p>
  </div>
        </div>
           <a-divider orientation="left">Target Audience & Details</a-divider>
           <div class="row">
            <div class="col-md-12 mb-2">
              <a-form-item
                label="Target audience"
              >
              <a-radio-group buttonStyle="solid"
                v-decorator="[
                    'target_audience',
                    {rules: [{ required: true, message: 'Please select an audience!!' }], initialValue: 0}
                  ]"
                   @change="handleTargetAudienceChange"
              >
                <a-radio-button v-for="targetAudianceType in targetAudianceTypes" :key="targetAudianceType.value" :value="targetAudianceType.value">
                  {{ targetAudianceType.name }}
                </a-radio-button>
              </a-radio-group>
              </a-form-item>
            </div>
           </div>
          <div class="row">
            <div class="col-md-4 mb-2">
              <a-form-item
                label="Session"
              >
                <a-select
                  v-decorator="[
                    'session_id',
                    {rules: [{ required: true, message: 'Please select a session!!' }], initialValue: currentSession ? currentSession.id : ''}
                  ]"
                  placeholder="Select session"
                  @change="handleSessionChange"
                >
                  <a-select-option v-for="schoolSession in schoolSessions" :value="schoolSession.id" :key="schoolSession.id">
                    {{schoolSession.name}}
                    <small class="text-primary ml-3">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <div class="col-md-4 mb-2">
              <a-form-item
                label="Class"
              >
                <a-spin :spinning="classSpinning">
                  <a-select
                    v-decorator="[
                      'class_id',
                      {rules: [{ required: true, message: 'Please select a class!!' }], initialValue: 0}
                    ]"
                    placeholder="Select class"
                    @change="handleClassSelect"
                    :disabled="!selectedSession"
                  >
                    <a-select-option :value="0">
                      All Class
                    </a-select-option>
                    <template v-for="schoolClass in schoolClasses">
                      <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                    {{schoolClass.name}}
                    </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>

            <div class="col-md-4 mb-2">
              <a-form-item
                label="Section"
              >
                <a-spin :spinning="sectionSpinning">
                  <a-select
                    v-decorator="[
                      'section_id',
                      {rules: [{ required: true, message: 'Please select a section!!' }], initialValue: 0}
                    ]"
                    placeholder="Select section"
                    :disabled="!form.getFieldValue('class_id')"
                  >
                      <a-select-option :value="0">
                        All Section
                      </a-select-option>
                      <a-select-option v-for="section in sections" :value="section.id" :key="section.id">
                      {{section.name}}
                      </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>

            <div class="col-md-6 d-none">
              <a-form-item
                label="Send notification on"
              >
              <a-date-picker
                format="DD-MM-YYYY hh:mm a"
                :disabledDate="disabledDate"
                placeholder="Select date & time"
                v-decorator="[
                  'notification_date_time',
                  {initialValue: undefined},
                ]"
                :showTime="{ format: 'hh:mm a', use12Hours: true }"
              />
              </a-form-item>
            </div>
          </div>
          <a-divider />
          <div class="holiday-summary mt-2 p-2 border rounded bg-light">
            <strong>Summary:</strong>
            <span>{{ holidaySummary }}</span>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { find, mapValues } from 'lodash'

import { eventTypes, targetAudianceTypes } from '@/services/globaldata'

import { makeEventData } from './fields'

export default {
  name: 'EditCalendarEvent',
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id

        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
    this.$eventBus.$on('openCalendarEventEditModal', this.showModal)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
    getWorkingDateRules() {
      return this.form.getFieldValue('in_attendance')
        ? [{ required: true, message: 'Please input working date(s)' }]
        : []
    },
    workingDaysData() {
      return this.workingDays.map(date => ({ date }))
    },
    holidaySummary() {
    // Destructure formValues from the reactive data property
      const { start_date: startDate, end_date: endDate, event_type: eventType, target_audience: targetAudience } = this.formValues
      const audienceObj = this.targetAudianceTypes.find(t => t.value === targetAudience)
      const audienceLabel = audienceObj ? audienceObj.name : 'N/A'
      const isHoliday = eventType === 'H'

      // Check for multi-day
      const isMultiDay = endDate && !moment(startDate).isSame(endDate, 'day')

      const startStr = moment(startDate).format('DD-MM-YYYY')
      const endStr = endDate ? moment(endDate).format('DD-MM-YYYY') : ''
      const eventTypeObj = this.eventTypes.find(e => e.value === eventType)

      // --- NON-HOLIDAY EVENT LOGIC ---
      if (!isHoliday) return `This ${eventTypeObj.name} is scheduled for ${startStr}${endDate ? ' to ' + endStr : ''}. Target audience: ${audienceLabel}.`

      // --- HOLIDAY LOGIC ---

      // 1. Single-Day Holiday
      if (!isMultiDay) {
        if (this.isWorkingDaysDisabled) return `This is a one-day holiday on ${startStr}. Staff working days are disabled because the audience is '${audienceLabel}'.`
        return `Holiday on ${startStr} for ${audienceLabel}. Both staff and students will be on holiday.`
      }

      // 2. Multi-Day Holiday
      const totalDays = this.workingDays.length
      const selectedCount = this.selectedDates.length

      if (this.isWorkingDaysDisabled) return `This is a multi-day holiday from ${startStr} to ${endStr} for ${audienceLabel}. Staff working days are disabled.`

      if (selectedCount > 0) return `This is a multi-day holiday from ${startStr} to ${endStr} (${totalDays} days total). Staff will work on ${selectedCount} day(s): ${this.selectedDates.join(', ')}.`

      return `This is a multi-day holiday from ${startStr} to ${endStr}. Both staff and students will be on holiday.`
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      spining: false,
      visible: false,
      eventId: null,
      dateFormat: 'DD-MM-YYYY',
      timeFormat: 'h:mm a',
      calendarEventDate: moment(),
      open: false,
      open2: false,
      eventTypes,
      targetAudianceTypes,
      isHoliday: false,
      workingDays: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedSession: undefined,
      classSpinning: false,
      sectionSpinning: false,
      selectedDate: null,
      selectedDates: [],
      isWorkingDaysDisabled: false,
      checkAll: false,
      isIndeterminate: false,
      workingDayColumns: [
        { title: 'Date', dataIndex: 'date', key: 'date' },
        { title: 'Select', key: 'checkbox', scopedSlots: { customRender: 'checkbox' } },
      ],
      formValues: {
        start_date: moment(),
        end_date: null,
        event_type: 'O',
        target_audience: 0,
      },
      selectedImage: null,
      existingImageUrl: null,
    }
  },
  methods: {
    moment,
    getFormValuesForSummary() {
      const { getFieldValue } = this.form
      return {
        start_date: getFieldValue('start_date'),
        end_date: getFieldValue('end_date'),
        event_type: getFieldValue('event_type'),
        target_audience: getFieldValue('target_audience'),
      }
    },
    // **CENTRAL UPDATE METHOD**
    updateFormValues() {
      // Update the reactive data property
      this.formValues = this.getFormValuesForSummary()
      this.isHoliday = this.formValues.event_type === 'H'

      // Re-generate working days list after date change
      this.generateWorkingDays()
    },
    showModal(event) {
      this.visible = true
      this.eventId = event.id
      this.calendarEventDate = moment(event.start)
      this.getEvent()
    },
    handleTimePickerOpenChange(open) {
      this.open = open
    },
    handleTimePickerClose() {
      this.open = false
      this.open2 = false
    },
    handleEventTypeChange(value) {
      this.isHoliday = value === 'H'
      this.$nextTick(() => {
        this.updateFormValues()
      })
    },
    handleCheckAllChange(e) {
      const checked = e.target.checked
      this.checkAll = checked
      this.isIndeterminate = false
      this.selectedDates = checked ? [...this.workingDays] : []
    },
    // When selecting individual dates
    handleCheckboxChange(e, date) {
      const checked = e.target.checked
      if (checked) {
        this.selectedDates.push(date)
      } else {
        this.selectedDates = this.selectedDates.filter(d => d !== date)
      }

      const total = this.workingDays.length
      const checkedCount = this.selectedDates.length

      this.checkAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },
    disabledDate(current) {
      // Can not select days before today
      return current < moment().startOf('day')
    },
    onEndDateChange(newValue) {
      console.log('End date changed:', newValue)
      if (newValue) {
        this.form.setFieldsValue({ in_attendance: false })
      }
    },
    disabledWorkingDate(current) {
      const startDate = this.form.getFieldValue('start_date')
      const endDate = this.form.getFieldValue('end_date')
      if (!startDate || !endDate) {
        return false // Allow selection if no start or end date is set
      }
      const start = moment(startDate).startOf('day')
      const end = moment(endDate).endOf('day')
      return current.isBefore(start) || current.isAfter(end)
    },
    handleDateChange(date, dateString) {
      if (dateString && !this.selectedDates.includes(dateString)) {
        this.selectedDates.push(moment(dateString).format('DD-MM-YYYY'))
      }
      this.selectedDate = null // Reset picker after each selection
    },
    removeDate(date) {
      this.selectedDates = this.selectedDates.filter(d => d !== date)
    },
    handleTargetAudienceChange(e) {
      const value = e.target.value
      this.$nextTick(() => {
        const studentAudienceType = find(this.targetAudianceTypes, ['name', 'Students'])
        const parentType = find(this.targetAudianceTypes, ['name', 'Parents'])
        const studentValue = studentAudienceType ? studentAudienceType.value : null
        const parentValue = parentType ? parentType.value : null

        // Disable working days if the audience is 'Students' or 'Parents'
        this.isWorkingDaysDisabled = value === studentValue || value === parentValue

        if (this.isWorkingDaysDisabled) {
          this.selectedDates = []
        }

        this.updateFormValues()
      })
    },
    generateWorkingDays() {
      const startDate = this.form.getFieldValue('start_date')
      const endDate = this.form.getFieldValue('end_date')

      if (!startDate || !endDate) {
        this.workingDays = []
        return
      }

      const start = moment(startDate)
      const end = moment(endDate)
      const days = []

      // include the same day if start === end
      for (let d = start.clone(); d.isSameOrBefore(end, 'day'); d.add(1, 'day')) {
        days.push(d.format('DD-MM-YYYY'))
      }

      this.workingDays = days
    },
    onStartOrEndDateChange() {
      this.$nextTick(() => {
        this.updateFormValues()
      })
    },
    getEvent: function() {
      this.spining = true
      this.$http.get(`/api/calendar/${this.eventId}`)
        .then(({ data }) => {
          this.spining = false
          const eventData = makeEventData(data.data)
          const fieldsData = mapValues({ ...eventData }, function(value) {
            return value !== null ? value : undefined
          })
          if (fieldsData.class_id) {
            this.getClassSections(fieldsData.class_id)
          }
          this.existingImageUrl = data.data.image_url ? data.data.image_url : null
          this.$nextTick(() => {
            this.form.setFieldsValue({ ...fieldsData })
            this.selectedDates = data.data.holiday_working_days ? data.data.holiday_working_days.map(h => moment(h.date, 'YYYY-MM-DD').format('DD-MM-YYYY')) : []
            this.updateFormValues()
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.form.resetFields(['section_id'])
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`)
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }

      this.form.resetFields(['class_id', 'section_id'])

      this.getClasses()
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update the event!`,
            onOk: () => {
              let eventValues = this.makeEventData(values)

              let formData = new FormData()
              for (const key in eventValues) {
                if (eventValues[key] !== undefined && eventValues[key] !== null) {
                  if (Array.isArray(eventValues[key])) {
                    eventValues[key].forEach(val => formData.append(`${key}[]`, val))
                  } else {
                    formData.append(key, eventValues[key])
                  }
                }
              }
              if (this.selectedImage) {
                formData.append('image', this.selectedImage)
              }
              formData.append('_method', 'PATCH')

              this.$http
                .post(`/api/calendar/${this.eventId}`, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                })
                .then(({ data }) => {
                  this.$emit('edited')
                  this.$eventBus.$emit('calendarEventUpdated')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated!',
                    description: `Event has been updated successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleDelete() {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Clicking Yes will delete this event.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/calendar/' + this.eventId)
            .then(() => {
              this.$emit('edited')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Event has been deleted.',
              })
              this.visible = false
            })
            .catch(error => {
              this.$nprogress.done()
              this.$notification['error']({
                message: error.message,
                description: 'Unable to delete event! Please try again.',
              })
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    makeEventData(values) {
      if (values.in_attendance) {
        values.in_attendance = 1
      } else values.in_attendance = 0

      if (values.weekend) {
        values.weekend = 1
      } else values.weekend = 0

      if (values.class_id === 0) delete values.class_id
      if (values.section_id === 0) delete values.section_id
      if (values.class_id === 0) delete values.class_id

      values.start_date = moment(values.start_date).format('YYYY-MM-DD')
      // values.end_date = moment(values.end_date).format('YYYY-MM-DD')

      if (values.end_date) {
        values.end_date = moment(values.end_date).format('YYYY-MM-DD')
      } else delete values.end_date

      if (values.start_time) {
        values.start_time = moment(values.start_time).format('HH:mm:ss')
      } else delete values.start_time

      if (values.end_time) {
        values.end_time = moment(values.end_time).format('HH:mm:ss')
      } else delete values.end_time

      if (values.notification_date_time) {
        values.send_notification = 1
        values.notification_date_time = moment(values.notification_date_time).format('YYYY-MM-DD HH:mm:ss')
      } else {
        values.send_notification = 0
        delete values.notification_date_time
      }

      if (values.all_day) {
        delete values.start_time
        delete values.end_time
      }

      delete values.all_day
      // Ensure selectedDates is included in values
      values.selectedDates = this.selectedDates ? [...this.selectedDates] : []
      // Format selectedDates if it exists
      if (values.selectedDates && Array.isArray(values.selectedDates)) {
        values.selectedDates = values.selectedDates.map(date => moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
      } else {
        values.selectedDates = []
      }

      return values
    },
    handleCancel(e) {
      this.form.resetFields()
      this.selectedImage = null
      this.existingImageUrl = null
      this.visible = false
    },
    handleImageChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.selectedImage = file
      } else {
        this.selectedImage = null
      }
    },
  },
}
</script>
